// IdleTimeTable.jsx
const mockIdle = [
  {
    sNo: 1,
    timeRange: "09:22 AM - 12:09 PM",
    duration: 167,
    map: "VWQ2+5FH, Baijpur, Betul, Madhya Pradesh 460001, India",
    locations: 8,
    distance: 20.53,
  },
  {
    sNo: 2,
    timeRange: "12:09 PM - 12:20 PM",
    duration: 11,
    map: "A/4, Baijpur, Betul, Madhya Pradesh 460001, India",
    locations: 1,
    distance: 0.0,
  },
];

export default function IdleTimeTable() {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-blue-400 p-6">
        <h2 className="text-2xl font-bold text-white">Idle Time Report</h2>
        <p className="text-blue-100 mt-2">Abhishek - 27 Oct 2025</p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead className="bg-blue-50 sticky top-0">
            <tr>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">S.No</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Time (Displacement 100 Meters)</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Duration (In Minutes)</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Map</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Locations</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Distance (Meters)</th>
            </tr>
          </thead>
          <tbody>
            {mockIdle.map((row) => (
              <tr key={row.sNo} className="hover:bg-gray-50 border-b border-gray-200">
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.sNo}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.timeRange}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.duration}</td>
                <td className="border border-gray-300 px-4 py-3 text-blue-600 hover:underline cursor-pointer">{row.map}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.locations}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.distance.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="bg-gray-50 px-6 py-4 flex gap-4 justify-center">
        <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 font-medium">Print</button>
        <button className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 font-medium">Close</button>
        <button className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 font-medium">Export to Excel</button>
      </div>
    </div>
  );
}
